/**
 * ADR-036/ADR-072: дефолт rate limit LLM Gateway. Единый источник для Zod-схемы
 * конфига и runtime-дефолтов (settings-роуты, fallback'и backend/core).
 */
export const DEFAULT_LLM_GATEWAY_RATE_LIMIT = {
    userPerMinute: 60,
    providerPerMinute: 120,
};
// --- LLM ---
/**
 * ADR-117: тир усилия модели (effort) — масштаб opencode
 * (`packages/ai/src/schema/options.ts`). Anthropic 5.x принимает его в
 * `output_config.effort`; передаётся из `ChatOptions.effort` (явно) либо
 * выводится из `reasoningLevel` (`effortForReasoningLevel`).
 */
export const EFFORT_LEVELS = ['low', 'medium', 'high', 'xhigh', 'max'];
/** Проверка, что значение — допустимый тир effort. */
export function isEffortLevel(value) {
    return typeof value === 'string' && EFFORT_LEVELS.includes(value);
}
/**
 * Маппинг `reasoningLevel` → `effort`.
 *
 * Только прямые соответствия `low|medium|high`; `default`/`none` — `undefined`
 * (параметр не отправляется), потому что «выключить размышления» через
 * effort-тир не выразить: у effort-моделей это другой режим, и выдумывать
 * значение нельзя. `xhigh`/`max` существуют только как явный `ChatOptions.effort`.
 */
export function effortForReasoningLevel(level) {
    if (level === 'low')
        return 'low';
    if (level === 'medium')
        return 'medium';
    if (level === 'high')
        return 'high';
    return undefined;
}
/**
 * Нормализованная причина завершения ответа модели (единый словарь для всех
 * протоколов).
 *
 * Зачем: провайдеры сообщают причину по-разному (`stop_reason` у Anthropic,
 * `finish_reason` у OpenAI-совместимых, `done_reason` у Ollama), а потребителю
 * (оркестратору) нужно отличать «модель ничего не сказала» от «ответ срезан
 * лимитом вывода»: при `max_tokens` пустой `content` — это не пустой ответ, а
 * исчерпанный бюджет (например, adaptive thinking съел весь `max_tokens`).
 *
 *  - `end_turn` — естественное завершение;
 *  - `tool_use` — модель просит вызвать инструмент;
 *  - `max_tokens` — ответ срезан лимитом вывода (в т.ч. весь ушёл в reasoning);
 *  - `stop_sequence` — сработала стоп-последовательность;
 *  - `length` — то же, что `max_tokens` (сырое значение Ollama/части API);
 *  - `content_filter` — завершение фильтром провайдера;
 *  - `error` — завершение по ошибке провайдера;
 *  - `unknown` — причина есть, но не распознана.
 */
export const LLM_FINISH_REASONS = [
    'end_turn',
    'tool_use',
    'max_tokens',
    'stop_sequence',
    'length',
    'content_filter',
    'error',
    'unknown',
];
